import React from 'react'
import BSForm from 'react-bootstrap/Form';
import ChipsControl from '../ChipsControl';

interface ChipsInputFieldProps {
    id: string
    label: string
    placeholder?: string
    required?: boolean
    value: Array<string>
    limit: number
    onChange?: (chips: Array<string>) => void
}

const ChipsInputField: React.FC<ChipsInputFieldProps> = ({ id, label, placeholder, required, value, limit, onChange }) => {
    return (
        <BSForm.Group>
            <BSForm.Label>{label}{required ? '*' : ""}</BSForm.Label>
            <ChipsControl
                id={id}
                placeholder={placeholder}
                chips={value}
                chipsLimit={limit}
                onChange={onChange} />
        </BSForm.Group>
    )
}

export default ChipsInputField